/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {formatIndian} from '../../../../utils/formatIndian';

const BarChartTooltip: React.FC<{
  active: any;
  payload: any;
  tooltipRef: any;
  bgColor: string;
}> = ({active, payload, tooltipRef, bgColor}) => {
  const isWhite = bgColor === '#FFFFFF';

  return (
    <div ref={tooltipRef} style={{width: '100%', height: '100%'}}>
      {active && payload ? (
        <Flex vertical={true} align="center" style={{overflow: 'hidden'}}>
          <Flex
            style={{
              height: '100%',
              backgroundColor: bgColor,
              borderRadius: isWhite ? '0rem' : '1rem',
              padding: '0rem 0.3rem'
            }}
            align="center"
            justify="center"
          >
            <div
              style={{
                width: 'fit-content',
                height: '100%',
                color: isWhite ? '#000000' : '#FFFFFF',
                font: 'normal normal 600 10px/13px Montserrat',
                margin: '0.2rem'
              }}
            >
              {`${formatIndian(payload?.[0]?.payload?.value)} ${
                payload?.[0]?.payload?.unit ?? ''
              }`}
            </div>
          </Flex>

          <div
            style={{
              width: '0',
              height: '0',
              borderLeft: '0.5rem solid transparent',
              borderRight: '0.5rem solid transparent',
              borderTop: `2rem solid ${bgColor}`,
              marginTop: '-1.3rem',
              zIndex: '-100'
            }}
          />
        </Flex>
      ) : null}
    </div>
  );
};

export default BarChartTooltip;
